import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";

type TitleAndTagsProps = {
  title?: string;
  url?: string;
  pathname?: string;
  description?: string;
};

export function TitleAndTags({
  title = "Skipper",
  url = "https://next.dev.skipper.io",
  description = "Homeschoolers can create and teach courses, connect your social groups, and manage learning at home, online, and in classrooms  - all in one place.",
  pathname,
}: TitleAndTagsProps) {
  const router = useRouter();
  const path = pathname || router.pathname;

  return (
    <Head>
      <title>{title} | Skipper</title>
      <meta name="description" content={description} property="description" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />

      <meta property="og:url" content={`${url}${path}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />

      <meta property="twitter:title" content="Login - Skipper.io" />
    </Head>
  );
}
